const riskLevels = [
  { level: 'Critical', color: '#EF4444' },
  { level: 'Medium', color: '#F59E0B' },
  { level: 'Low', color: '#22C55E' },
];

const zoneAssetConfig = {
  'finishing-zone': {
    names: [
      'CNC Lathe Alpha',
      'CNC Lathe Beta',
      'Surface Grinder SG-01',
      'Polishing Station PS-04',
      'Deburring Machine DB-02',
      'Coating Booth CB-06',
      'Inspection Station IS-03',
      'Honing Machine HM-07',
    ],
    issues: [
      'Unusual vibration detected',
      'Temperature anomaly detected',
      'Bearing wear detected',
      'Oil pressure fluctuation',
      'Motor current spike detected',
      'Alignment issue detected',
    ],
  },
  'assembly-zone': {
    names: [
      'Welding Robot W-22',
      'Welding Robot W-31',
      'Torque Station T-05',
      'Rivet Press RP-12',
      'Assembly Conveyor AC-03',
      'Pick & Place PP-08',
      'Screw Driver SD-14',
      'Press Fit PF-09',
    ],
    issues: [
      'Calibration drift detected',
      'Torque variance detected',
      'Cycle time increasing',
      'Pneumatic pressure drop',
      'Servo motor overheating',
      'Belt tension anomaly',
    ],
  },
  'packaging-zone': {
    names: [
      'Heat Sealer HS-08',
      'Label Printer LP-02',
      'Palletizer P-01',
      'Shrink Wrapper SW-05',
      'Carton Former CF-11',
      'Tape Dispenser TD-03',
      'Stretch Wrapper STW-06',
      'Case Packer CP-09',
    ],
    issues: [
      'Sealing temperature unstable',
      'Label misalignment detected',
      'Hydraulic pressure decline',
      'Film tension irregular',
      'Glue nozzle clogging',
      'Motor vibration increasing',
    ],
  },
};

const assetImages = [
  '/images/cnc-lathe-1.png',
  '/images/cnc-lathe-2.png',
  '/images/cnc-lathe-3.png',
  '/images/cnc-lathe-4.png',
];

const supervisors = ['John Smith', 'Sarah Johnson', 'Mike Chen', 'Lisa Rodriguez'];
const technicians = ['Alex Brown', 'Emma Wilson', 'David Lee', 'Maria Garcia', 'Tom Anderson'];

const zoneLocationMap = {
  'finishing-zone': 'Workspace East > Zone 48 > Finishing Zone',
  'assembly-zone': 'Workspace West > Zone 12 > Assembly Zone',
  'packaging-zone': 'Workspace North > Zone 25 > Packaging Zone',
};

const riskPriorityMap = { Critical: 'High', Medium: 'Moderate', Low: 'Low' };
const riskHealthMap = { Critical: 55, Medium: 72, Low: 88 };
const riskFailureProbMap = { Critical: 85, Medium: 45, Low: 15 };
const riskTimeframeMap = { Critical: 'within 7 days', Medium: 'within 1 month', Low: 'within 3 months' };
const riskSeverityMap = {
  Critical: { severity: 'Emergency Maintenance', description: 'Immediate attention required to prevent failure' },
  Medium: { severity: 'Scheduled Maintenance', description: 'Schedule maintenance during next downtime window' },
  Low: { severity: 'Preventive Maintenance', description: 'Monitor and plan routine inspection' },
};

const makes = ['CSB Industries', 'FluidTech Inc', 'PowerDrive Corp', 'HydroMax Ltd'];
const types = ['Pump', 'Motor', 'Hydraulic', 'CNC', 'Conveyor', 'Robotic'];

const generateAssetsForZone = (zoneId, count) => {
  const config = zoneAssetConfig[zoneId];
  const assets = [];
  for (let i = 1; i <= count; i++) {
    const risk = riskLevels[i % 3];
    const rulDays = risk.level === 'Critical' ? Math.floor(Math.random() * 15) + 5
      : risk.level === 'Medium' ? Math.floor(Math.random() * 25) + 15
      : Math.floor(Math.random() * 60) + 30;

    const healthScore = riskHealthMap[risk.level] + (i % 7) - 3;
    const assetName = config.names[(i - 1) % config.names.length];
    const issueText = config.issues[(i - 1) % config.issues.length];
    const confidenceVal = Math.floor(Math.random() * 36) + 65;
    const locationParts = zoneLocationMap[zoneId].split(' > ');
    const rulStr = rulDays <= 30 ? `${rulDays} days` : `${Math.floor(rulDays / 30)} Month ${rulDays % 30} days`;
    const workOrderCount = Math.floor(Math.random() * 6) + 1;
    const nextServiceStr = `${Math.floor(Math.random() * 28) + 1} Mar 2026`;

    assets.push({
      id: i,
      name: assetName,
      fullName: assetName,
      image: assetImages[(i - 1) % assetImages.length],
      issue: issueText,
      status: i % 5 === 0 ? 'Offline' : 'Online',
      riskLevel: risk.level,
      riskColor: risk.color,
      priority: riskPriorityMap[risk.level],
      location: {
        full: zoneLocationMap[zoneId],
        workspace: locationParts[0] || '',
        zone: locationParts[1] || '',
        area: locationParts[2] || '',
      },
      healthScore,
      rul: { label: 'Remaining Useful Life', value: rulStr },
      rulColor: risk.color,
      failuresLastMonth: Math.floor(Math.random() * 10) + 1,
      lastChecked: `${Math.floor(Math.random() * 30) + 1} mins ago`,
      supervisor: supervisors[(i - 1) % supervisors.length],
      technician: technicians[(i - 1) % technicians.length],
      confidence: confidenceVal,
      rulPercentage: Math.floor(Math.random() * 36) + 65,
      zone: zoneId,
      failurePrediction: `${riskFailureProbMap[risk.level]}% failure probability`,
      failureProbability: riskFailureProbMap[risk.level],
      failureTimeframe: riskTimeframeMap[risk.level],
      workOrders: { label: 'Open Work Orders', value: workOrderCount },
      workOrderId: `WO-${zoneId.charAt(0).toUpperCase()}${String(i).padStart(4, '0')}`,
      nextService: { label: 'Next Scheduled Service', value: nextServiceStr },
      model: `MDL-${zoneId.charAt(0).toUpperCase()}${i}`,
      type: types[(i - 1) % types.length],
      make: makes[(i - 1) % makes.length],
      detailLocation: locationParts[0],
      recommendedAction: riskSeverityMap[risk.level],
      alert: {
        type: risk.level === 'Critical' ? 'error' : 'warning',
        message: issueText,
        confidence: `${confidenceVal}%`,
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: risk.level === 'Critical' ? 85 + (i % 15) : risk.level === 'Medium' ? 65 + (i % 10) : 40 + (i % 15),
          unit: '\u00B0C',
          normal: '20-60',
          normalRange: '20-60',
        },
        vibration: {
          label: 'Vibration',
          value: risk.level === 'Critical' ? 5.5 + (i % 3) : risk.level === 'Medium' ? 3.5 + (i % 2) : 1.5 + (i % 2) * 0.5,
          unit: 'mm/s',
          normal: '0-3',
          normalRange: '0-3',
        },
        pressure: {
          label: 'Pressure',
          value: +(2.5 + (i % 8) * 0.1).toFixed(1),
          unit: 'bar',
          normal: '2.5-3.2',
          normalRange: '2.5-3.2',
        },
      },
    });
  }
  return assets;
};

// Pre-generate assets for each zone (seeded with consistent data)
const assetsByZone = {
  'finishing-zone': generateAssetsForZone('finishing-zone', 32),
  'assembly-zone': generateAssetsForZone('assembly-zone', 28),
  'packaging-zone': generateAssetsForZone('packaging-zone', 24),
};

export const getAssetsByZone = (zoneId) =>
  assetsByZone[zoneId] || assetsByZone['finishing-zone'];

// Backward-compatible: default to finishing zone
export const allAssets = assetsByZone['finishing-zone'];

export const criticalityOptions = ['All Criticalities', 'Critical', 'Medium', 'Low'];
export const supervisorOptions = ['All Supervisors', ...supervisors];
export const technicianOptions = ['All Technicians', ...technicians];
